<template>
  <div class="box"> 
    <van-loading class="loading" type="spinner" v-if="Loading">加载中...</van-loading>
    <div class="infoList" v-if="info !== '0' && !Loading">
      <div
        class="con"
        @click="toDetail(item)"
        v-for="item in info"
        :key="item.spno"
      >
        <div class="conTit">
          <p>
            <span>补卡</span>
            <span v-if="item.spstatus === '1'" class="op-1">审批中</span>
            <span v-else-if="item.spstatus === '2'" class="op-2">已通过</span>
            <span v-else-if="item.spstatus === '3'" class="op-3">已驳回</span>
            <span v-else-if="item.spstatus === '4'" class="op-3">已撤销</span>
            <span v-else-if="item.spstatus === '6'" class="op-1"
              >通过后撤销</span
            >
            <span v-else-if="item.spstatus === '7'" class="op-1">已删除</span>
            <span v-else-if="item.spstatus === '10'" class="op-1">已支付</span>
          </p>
          <span>{{ item.time }}</span>
        </div>
        <div class="conBox">
          <p>异常类型：{{ item.abnormaltypetext }}</p>
          <p>职位类型：{{ item.positiontypetext }}</p>
          <p>签卡时间：{{ item.registrationcarddatetext }}</p>
        </div>
      </div>
    </div>
    <div class="noBox" v-if="info === '0' && !Loading">暂无补卡记录...</div>
  </div>
</template>

<script>
// import moment from "moment";
import api from "@/apis";
import { getToken } from "@/utils/cookie";
import moment from "moment";
export default {
  name: "infoList",
  data() {
    return {
      info: [],
      spno: "",
      Loading : true
    };
  },
  created() {},
  mounted() {
    setTimeout(()=>{
      this.getData();
      this.Loading = false
    },2000)
  },
  // watch: {
  //   info() {
  //     this.getData();
  //   },
  // },
  methods: {
    //跳转详情页
    toDetail(item) {
      this.spno = item.spno;
      this.$router.push({
        path: "/mobile/detail",
        query: {
          spno: this.spno,
        },
      });
    },
    //获取补卡记录
    getData() {
      api.selectCardByEmpNo({ empNo: getToken() }).then((data) => {
        this.info = data.data;
        this.info.forEach((item) => {
          item.time = moment(item.createTime).format("hh:mm");
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .infoList,.loading {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .infoList,.loading {
    width: 276px * $zoom;
  }
}
.box {
  display: flex;
  justify-content: center;
}
.infoList {
  font-size: 22px * $zoom;
  min-height: 100vh;
  background: #f4f5f8;
  position: relative;
}
.loading{
  min-height: 100vh;
  background: #f4f5f8;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.noBox {
  font-size: 12px * $zoom;
  min-height: 100vh;
  background: #f4f5f8;
  width: 100%;
}
.con {
  border-bottom: 1px solid rgb(228, 227, 227);
}
.conTit {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 30px;
  padding: 10px 20px;
  & > span {
    color: rgb(119, 118, 118);
  }
  p span:nth-child(1) {
    font-weight: bold;
  }
  .op-1 {
    color: #fff;
    background: rgb(212, 166, 13);
    margin-left: 15px;
    padding: 1px 5px;
    border-radius: 5px;
  }
  .op-2 {
    color: #fff;
    background: rgb(106, 177, 1);
    margin-left: 15px;
    padding: 1px 5px;
    border-radius: 5px;
  }
  .op-3 {
    color: #fff;
    background: rgb(240, 75, 34);
    margin-left: 15px;
    padding: 1px 5px;
    border-radius: 5px;
  }
}
.conBox {
  font-size: 28px;
  padding: 5px 20px 15px;
  p {
    margin-bottom: 10px;
  }
}
</style>
